// Angular Core
import { Routes } from '@angular/router';

// Components
import { ForgotPasswordPage } from './pages/ForgotPasswordPage/forgot-password-page.component';
import { LoginPage } from './pages/LoginPage/login-page.component';
import { ResetPasswordPage } from './pages/ResetPasswordPage/reset-password-page.component';

// Guards
import { authGuard } from './guards/AuthGuard/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginPage,
  },
  {
    path: 'recover-password',
    component: ForgotPasswordPage,
  },
  {
    path: 'password/reset/:id',
    component: ResetPasswordPage,
  },
  {
    path: 'app',
    loadComponent: () =>
      import('./modules/main/main-module.component').then((c) => c.MainModule),
    loadChildren: () =>
      import('./routes/main-routes').then((r) => r.mainRoutes),
    canActivate: [authGuard],
  },
  {
    path: '**',
    redirectTo: '/login',
  },
];
